import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_FUEL_RESET = 'POST_FUEL_RESET';
export const POST_FUEL_LOADING = 'POST_FUEL_LOADING';
export const POST_FUEL_SUCCESS = 'POST_FUEL_SUCCESS';
export const POST_FUEL_REJECT = 'POST_FUEL_REJECT';

//* ACTIONS ------------------------------------------------
export const postFuelReset = () => ({ type: POST_FUEL_RESET });
export const postFuelLoading = () => ({ type: POST_FUEL_LOADING });
export const postFuelSuccess = (payload) => ({ type: POST_FUEL_SUCCESS, payload });
export const postFuelReject = (payload) => ({ type: POST_FUEL_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postFuelRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data: {
            fuelType: data.fuelType,
            startDate: data.startDate,
            endDate: data.endDate,
            price: data.price,
        },
    }, getState);
    return request(`/Fuels/web/AddFuels`, options);
};


